import { post, get as apiGet } from 'api'

export const getAll = async () => apiGet(`/template/getList`)

export const get = async id => apiGet(`/template/${id}`)

export const update = async values => post('/template/save', values)

export const deleteItem = async id => post(`/template/delete/${id}`)
